import React from 'react';
import {useTranslation} from 'next-i18next';
import type {StaticImageData} from 'next/image';
import {
	Box,
	Heading,
	HStack,
	Image,
	SimpleGrid,
	Text,
	VStack,
} from '@tempo/core';
import D4CMockupImage from '@deezer/next/assets/img/landing/DfC-mockup.png';

type DescriptionSectionProps = {
	title: string;
	description: string;
};

const DescriptionSection = ({title, description}: DescriptionSectionProps) => {
	return (
		<VStack
			as="li"
			alignItems={{base: 'center', md: 'flex-start'}}
			textAlign={{base: 'center', md: 'left'}}
			spacing="spacing.l"
		>
			<Heading as="h2" variant="title.screen.mobile">
				{title}
			</Heading>
			<Text
				variant="body.default.regular"
				color="text.neutral.secondary.default"
			>
				{description}
			</Text>
		</VStack>
	);
};

const BackstageDescription = () => {
	const {t} = useTranslation('d4c');

	return (
		<Box
			as="section"
			maxW="container.lg"
			margin="auto"
			px="spacing.l"
			id="backStageDescription"
		>
			<HStack
				spacing={{base: 0, md: 'spacing.3xl'}}
				justifyContent={{base: 'center', md: 'flex-start'}}
			>
				<Box display={{base: 'none', md: 'block'}}>
					<Image
						src={(D4CMockupImage as unknown as StaticImageData).src}
						alt="Deezer for Creators on mobile"
					/>
				</Box>
				<Box
					as="article"
					pt="spacing.3xl"
					pb="96px"
					px="spacing.l"
					maxW={{base: 'container.xs', md: '60%'}}
					margin="auto"
				>
					<Heading
						as="h1"
						variant="title.screen.mobile"
						pb="size.2xl"
						textAlign={{base: 'center', md: 'left'}}
					>
						{t('unloggedhomepage_title_whychooseXappname_d4c-web', {
							sprintf: ['Deezer for Creators'],
						})}
					</Heading>

					<SimpleGrid
						as="ul"
						columns={{base: 1, md: 2}}
						spacing={{base: 'spacing.3xl', md: 'spacing.l'}}
					>
						<DescriptionSection
							title={t('unloggedhomepage_title_showtheworldwhoyouare_d4c-web')}
							description={t(
								'unloggedhomepage_text_showtheworldwhoyouare_d4c-web',
							)}
						/>

						<DescriptionSection
							title={t('unloggedhomepage_title_dontmissabeat_d4c-web')}
							description={t('unloggedhomepage_text_dontmissabeat_d4c-web')}
						/>

						<DescriptionSection
							title={t('unloggedhomepage_title_sharewithyourcommunity_d4c-web')}
							description={t(
								'unloggedhomepage_text_sharewithyourcommunity_d4c-web',
							)}
						/>

						<DescriptionSection
							title={t('unloggedhomepage_title_trackyourreleases_d4c-web')}
							description={t('unloggedhomepage_text_trackyourreleases_d4c-web')}
						/>
					</SimpleGrid>
				</Box>
			</HStack>
		</Box>
	);
};

export default BackstageDescription;
